import type { OsmGroupAssignment } from './osm-group-mapping';
import type { OsmGroupOverride } from './overridesRuntime';

/**
 * Aplica correcciones de cableado OSM→grupo sobre el mapeo generado.
 * Cada override reemplaza (o añade) la entrada de su `osmId`; `distanceM`
 * queda a 0 (ya no es una estimación nearest-neighbor, es una asignación
 * confirmada a mano) y `osmDirection` se hereda de la entrada previa si
 * existía, o `null` si es una asignación nueva.
 */
export function applyOsmGroupOverrides(
  base: OsmGroupAssignment[],
  overrides: OsmGroupOverride[],
): OsmGroupAssignment[] {
  if (overrides.length === 0) return base;
  const byOsmId = new Map(base.map(m => [m.osmId, m]));
  for (const o of overrides) {
    const previous = byOsmId.get(o.osmId);
    byOsmId.set(o.osmId, {
      osmId: o.osmId,
      cabinetId: o.cabinetId,
      groupId: o.groupId,
      distanceM: 0,
      osmDirection: previous?.osmDirection ?? null,
    });
  }
  return Array.from(byOsmId.values());
}
